import { NgClass } from '@angular/common';
import { Component, input, model } from '@angular/core';

@Component({
  selector: 'app-portal-input',
  imports: [NgClass],
  templateUrl: './portal-input.component.html',
  styleUrl: './portal-input.component.css',
})
export class PortalInputComponent {
  // form = input<FormGroup>();
  placeholder = input('placeholder');
  showError = input(false);
  errorMessage = input('Something went wrong');
  value = model('');
}
